import * as Rx from 'rxjs';
import {ApiClient} from "./util";
import {environment} from "../../env/environment";
import {Mag2User} from "../entity/mag2-user";
import { LogoutRes } from "src/lib/entity/auth";
import {Mag2LocalStorage} from "../mag2-local-storage";
import {Mag2TermsAgreementStatus} from "../entity/mag2-terms-agreement-status";
import {catchError, map} from "rxjs/operators";

/**
 * まぐまぐ本体側の API を呼び出す API Client.
 */
export class Mag2ApiClient {

  /**
   * まぐまぐへのログイン状態に紐づくユーザー情報を取得する。
   * 本番環境以外ではログイン API を利用できないため、Cookie に入っている __USER_ID を認証代わりに利用するので、実際には API を呼び出さない。
   * この Cookie の __USER_ID は /debug ページでセット可能。
   */
  static getUser(): Rx.Observable<Mag2User | null> {
    if (environment.name === 'local' || window.location.hostname === 'localhost') {
      const userId = Mag2LocalStorage.getUserId();
      if (userId === null) {
        // noinspection JSDeprecatedSymbols
        return Rx.of(null);
      }
      // noinspection JSDeprecatedSymbols
      return Rx.of({
        suspendFlag: false,
        userId
      })
    }

    return ApiClient.getJson(environment.baseURL.mag2mypage, `api/v1/user/status`).pipe(
      catchError(e => {
        if (e.status === 404) {
          return Rx.of(null);
        } else {
          throw e;
        }
      })
    )
  }

  static getTermsAgreementStatus(): Rx.Observable<Mag2TermsAgreementStatus> {
    if (environment.name === 'local' || window.location.hostname === 'localhost') {
      // for debug
      // return Rx.throwError(new Error("server error"))
      // return Rx.of({agreed: false})
      return Rx.of({agreed: true});
    }
    return ApiClient.getJson(environment.baseURL.mag2mypage, `api/v1/user/terms/maglive`)
  }

  static putTermsAgreementStatus(status: Mag2TermsAgreementStatus): Rx.Observable<void> {
    if (environment.name === 'local' || window.location.hostname === 'localhost') {
      // for debug
      // return Rx.throwError(new Error("server error"))
      return Rx.of();
    }
    return ApiClient.putJson(environment.baseURL.mag2mypage, `api/v1/user/terms/maglive`, status)
  }

  /**
   * まぐまぐのログアウトAPIを呼び出す。
   */
  static logout(): Rx.Observable<LogoutRes | "NOT_AUTHORIZED"> {
    return ApiClient.deleteJson(environment.baseURL.mag2mypage, `api/v1/auth/logout`).pipe(
      map(x => {
        const resp = x as MagliveApiResponse<LogoutRes>;
        return resp.data;
      }),
      catchError(e => {
        if (e.status === 401) {
          return Rx.of("NOT_AUTHORIZED" as "NOT_AUTHORIZED");
        } else {
          throw e;
        }
      })
    )
  }
}

type MagliveApiResponse<T> = {
  status: number
  data: T
}
